module.exports = __webpack_public_path__ + "img/symbol_6.442edcde.png";